class ProductGrid extends HTMLElement {
  constructor() {
    super();
  }

  get nextUrl() {
    return this.dataset.nextUrl;
  }

  connectedCallback() {
    this.loadMoreButton = this.querySelector("button[id='product-grid__load-more-button']");
    this.productGridContainer = this.querySelector("#product-grid__container");

    this.handleClick = this.handleClick.bind(this);

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback() {
    if (this.loadMoreButton) {
      this.loadMoreButton.removeEventListener('click', this.handleClick);
    }
  }

  handleClick(event) {
    fetch(this.nextUrl)
      .then(response => response.text())
      .then((html) => {

        // get the next URL
        const parser = new DOMParser();
        const nextPage = parser.parseFromString(html, "text/html");
        const nextUrl = nextPage.querySelector("product-grid").dataset.nextUrl;

        // update data-next-url of <product-grid>
        this.dataset.nextUrl = nextUrl;

        // remove button
        if (!nextUrl) {
          event.target.remove();
        }

        // append products in next URL to the <product-grid>
        const prodCards = nextPage.querySelectorAll("#product-card");
        const variantCards = nextPage.querySelectorAll("#variant-card");
        prodCards.forEach((card) => {
          this.productGridContainer.append(card);
        })
        variantCards.forEach((card) => {
          this.productGridContainer.append(card);
        })

      })
      .catch((error) => {
        console.error('Error: ', error);
      })
  }
}

customElements.define('product-grid', ProductGrid)
